import httpClient from "../httpClient";
// import * as QueryString from "querystring";
const Qs = require('qs');
const getCards = () => httpClient.get(`/admin/dashboard/cards/`)
const getWorkingUser = () => httpClient.get(`/account/list-users/?page_size=-1&is_working=true`)
const getTimeSpentProjects = (params) => httpClient.get(`/record/project-report-for-admin/?page_size=${params.page_size}&from_date=${params.f_date}`)
const addUsers = () => httpClient.get(`/admin/users/add-user/`)
const addProjects = (params) => httpClient.post(`/admin/projects/add-project/`, params)

const chartActivity = (params) => httpClient.get(`/record/chart-activity/`, {
        params: params,
        paramsSerializer: function(params) {
            return Qs.stringify(params, {arrayFormat: 'repeat'})
        }
    })
const chartActivitySingleUser = (params) => httpClient.get(`/record/single-user-chart-data/`, {
        params: params,
    })

const lastActivities = (params) => httpClient.get('/record/times', {
    params: params
})

export {
    getCards,
    getWorkingUser,
    getTimeSpentProjects,
    addUsers,
    addProjects,
    chartActivity,
    chartActivitySingleUser,
    lastActivities
}
